import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIconGrey } from "../../assests/icons/user_info_grey_home.svg";
import { ReactComponent as HomeIconRed } from "../../assests/icons/user_info_red_home.svg";
import { Box, Tooltip } from "@mui/material";
import { protocol,hostname, redirectToConnectHome } from "../../utils/config";
import { useTranslation } from "react-i18next";
import { homeToken } from "../../utils/constant";

import {
  StyledMenu,
  HeaderUserInfoButton,
  HeaderUserInfoButtonInnerBox,
  UserAvatar,
  HeaderUserName,
  StyledMenuItem
} from "./HeaderUserInfo.styles";
import { ReactComponent as DropdownArrow } from "../../assests/icons/dropdown_arrow.svg";



const HeaderUserInfo = () => {
  const profileDetails = useSelector(state => state.profileDetails);
  const isHeaderShrink = useSelector(state=>state.header.isHeaderShrink);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isHover, setIsHover] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleGoToHome = () => {
    setAnchorEl(null);
    redirectToConnectHome();
  };

  return (
    <Box component={"div"}>
      <Tooltip
       title={Object.keys(profileDetails.data).length > 0 ? profileDetails.data.displayName.value : 'Hello User'}
       placement="left"
       disableHoverListener = {Object.keys(profileDetails.data).length && profileDetails.data.displayName.value.length <= 18}
       componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#ffffff",
            color: "#676767",
            boxShadow: "1px 1px 1px 1px #c8c8c8",
            textTransform:"capitalize",
            "& .MuiTooltip-arrow": {
              color: "#cf2030",
            },
          },
        },
      }}
       >
      <HeaderUserInfoButton
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        disableRipple
        onClick={handleClick}
        endIcon={
          anchorEl ? (
            <DropdownArrow style={{ transform: "rotate(180deg)" }} />
          ) : (
            <DropdownArrow />
          )
        }
      >
        <HeaderUserInfoButtonInnerBox component={"div"}>
          <UserAvatar isHeaderShrink={isHeaderShrink} alt={Object.keys(profileDetails.data).length > 0 ? profileDetails.data.displayName.value : ''} src={Object.keys(profileDetails.data).length > 0 &&(profileDetails.data.profileImageId.value?`${protocol}${hostname}:443//core-api/public/image/${profileDetails.data.profileImageId.value}`:`${profileDetails.data.displayName.value}`)} />
          <HeaderUserName >
            {Object.keys(profileDetails.data).length > 0 ? profileDetails.data.displayName.value : 'Hello User'}
          </HeaderUserName>
        </HeaderUserInfoButtonInnerBox>
      </HeaderUserInfoButton>
      </Tooltip>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <StyledMenuItem
        isHeaderShrink={isHeaderShrink}
        onClick={handleGoToHome}   
        onMouseEnter={(e) => {e.target.style.color = '#cf2030';setIsHover(true)}}
        onMouseLeave={(e) => {e.target.style.color = '#676767';setIsHover(false)}}
        disableRipple>
          { isHover?<HomeIconRed/>: <HomeIconGrey/>} 
          {t(homeToken.Home)}
        </StyledMenuItem>
      </StyledMenu>
    </Box>
  );
};

export default HeaderUserInfo;
